import moment from 'moment-timezone';
import { sortBy, uniqBy } from 'lodash';

// The short code we use for Arizona time
const phoenixShortCode = 'MST - Arizona';
const USTimezones = moment.tz.zonesForCountry('US').filter(timezone => {
  return timezone !== 'America/Phoenix';
});
const USTimezoneSelectOptions = uniqBy(
  sortBy(
    USTimezones.map(zone => ({
      label: moment.tz(zone).format('z'),
      value: zone,
    })),
    ['label']
  ),
  'label'
);

USTimezoneSelectOptions.push({
  label: phoenixShortCode,
  value: 'America/Phoenix',
});
const convertToReadableShortCode = (timezone: string) => {
  if (timezone === 'America/Phoenix') {
    return phoenixShortCode;
  } else {
    return moment.tz(timezone).format('z');
  }
};

const userTimezoneReadableShortcode = convertToReadableShortCode(moment.tz.guess());
const userTimezoneDefaultOption = USTimezoneSelectOptions.find(
  option => option.label === userTimezoneReadableShortcode
);
const userTimezoneDefaultValue = userTimezoneDefaultOption?.value;

export default {
  userTimezoneDefaultValue,
  USTimezoneSelectOptions,
  convertToReadableShortCode,
  userTimezoneReadableShortcode,
};
